angular.module('zc.projects')

.directive 'campaignTemplateItem', ($modal, $translate, Image, lib) ->
  restrict: 'E'
  scope:
    campaign: '='
    item: '='
    disabled: "@"
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_template_item.html'
  link: (scope, element, attrs) ->
    scope.browseImages = (elemName) ->
      $modal.open
        templateUrl: '/templates/projects.campaigns/views/image_browser.html'
        controller: "ImageBrowserController"
        size: 'lg'
        resolve:
          images: ->
            Image.all projectId: scope.campaign.project_id
          currentImageUrl: ->
            scope.campaign.element.message[elemName]
      .result
      .then (selectedItem) ->
        scope.campaign.element.message[elemName] = selectedItem.image_url



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_template_item.coffee